"use client";
import { jsx as t } from "react/jsx-runtime";
import o from "@emotion/styled";
import { MEDIA_QUERIES as e } from "../../tokens/media-queries/MediaQueries.js";
import { SPACINGS as r } from "../../tokens/spacings/Spacings.js";
import { forwardRef as p } from "react";
const d = p(({ children: i, ...a }, m) => /* @__PURE__ */ t(s, { ...a, "data-comp": "grid", ref: m, children: i }));
d.displayName = "Grid";
const x = d, s = o.div`
	display: grid;
	gap: ${r.md};
	grid-template-columns: repeat(12, minmax(0, 1fr));

	@media screen and (${e.tablet}) {
		gap: ${r.xl};
	}

	@media screen and (${e.widescreen}) {
		gap: ${r.xxl};
	}
`;
export {
  x as default
};
